export default {
  games: [
    {
      gameKey: 'BCSlot',
      name: 'Book of Cleopatra',
      gameType: 'SLOT',
      jackpotName: undefined,
      denominations: {
        EUR: [1, 5, 10, 25, 50, 100],
        USD: [1, 5, 10, 25, 50, 100],
        EGT: [1, 5, 10, 25, 50, 100],
      },
      betRanges: {
        EUR: { minBet: 100, maxBet: 10000 },
        USD: { minBet: 100, maxBet: 10000 },
        EGT: { minBet: 100, maxBet: 10000 },
      },
      branding: null,
      isInTournament: false,
    },
    {
      gameKey: 'EPSlot',
      name: 'Egyptian Pyramids',
      gameType: 'SLOT',
      jackpotName: undefined,
      denominations: {
        EUR: [1, 5, 10, 25, 50, 100],
        USD: [1, 5, 10, 25, 50, 100],
        EGT: [1, 5, 10, 25, 50, 100],
      },
      betRanges: {
        EUR: { minBet: 100, maxBet: 10000 },
        USD: { minBet: 100, maxBet: 10000 },
        EGT: { minBet: 100, maxBet: 10000 },
      },
      branding: null,
      isInTournament: false,
    },
    {
      gameKey: 'FDSlot',
      name: 'Flaming Dice',
      gameType: 'SLOT',
      jackpotName: undefined,
      denominations: {
        EUR: [1, 5, 10, 25, 50, 100],
        USD: [1, 5, 10, 25, 50, 100],
        EGT: [1, 5, 10, 25, 50, 100],
      },
      betRanges: {
        EUR: { minBet: 100, maxBet: 10000 },
        USD: { minBet: 100, maxBet: 10000 },
        EGT: { minBet: 100, maxBet: 10000 },
      },
      branding: null,
      isInTournament: false,
    },
    {
      gameKey: 'ProJackpot',
      name: 'Progressive Jackpot',
      gameType: 'SLOT',
      jackpotName: 'progressive',
      denominations: {
        EUR: [1, 5, 10, 25, 50, 100],
        USD: [1, 5, 10, 25, 50, 100],
        EGT: [1, 5, 10, 25, 50, 100],
      },
      betRanges: {
        EUR: { minBet: 100, maxBet: 10000 },
        USD: { minBet: 100, maxBet: 10000 },
        EGT: { minBet: 100, maxBet: 10000 },
      },
      branding: null,
      isInTournament: false,
    },
    {
      gameKey: 'InstGame1',
      name: 'Instant Win Game',
      gameType: 'INSTANT',
      jackpotName: undefined,
      betOptions: {
        EUR: [100, 500, 1000, 2500, 5000],
        USD: [100, 500, 1000, 2500, 5000],
        EGT: [100, 500, 1000, 2500, 5000],
      },
      denominations: {
        EUR: [1],
        USD: [1],
        EGT: [1],
      },
      branding: null,
      isInTournament: false,
    },
  ],
  groups: [
    {
      name: 'ALL',
      active: true,
      order: 1,
      games: [
        { gameKey: 'BCSlot', order: 1, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'EPSlot', order: 2, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'FDSlot', order: 3, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'ProJackpot', order: 4, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'InstGame1', order: 5, imageLobby: 'vertical', imageSection: 'vertical' },
      ],
    },
    {
      name: 'SLOTS',
      active: true,
      order: 2,
      games: [
        { gameKey: 'BCSlot', order: 1, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'EPSlot', order: 2, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'FDSlot', order: 3, imageLobby: 'vertical', imageSection: 'vertical' },
      ],
    },
    {
      name: 'PROGRESSIVE',
      active: true,
      order: 3,
      jackpotName: 'progressive',
      games: [{ gameKey: 'ProJackpot', order: 1, imageLobby: 'vertical', imageSection: 'vertical' }],
    },
    {
      name: 'INSTANT',
      active: true,
      order: 4,
      games: [{ gameKey: 'InstGame1', order: 1, imageLobby: 'vertical', imageSection: 'vertical' }],
    },
    {
      name: 'TOP_GAMES',
      active: true,
      order: 5,
      topLimit: 6,
      games: [
        { gameKey: 'BCSlot', order: 1, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'EPSlot', order: 2, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'BCSlot', order: 3, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'EPSlot', order: 4, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'BCSlot', order: 5, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'EPSlot', order: 6, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'BCSlot', order: 7, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'EPSlot', order: 8, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'BCSlot', order: 9, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'EPSlot', order: 10, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'BCSlot', order: 11, imageLobby: 'vertical', imageSection: 'vertical' },
      ],
    },
    {
      name: 'TOURNAMENTS',
      active: true,
      order: 6,
      games: [
        { gameKey: 'BCSlot', order: 1, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'EPSlot', order: 2, imageLobby: 'vertical', imageSection: 'vertical' },
        { gameKey: 'FDSlot', order: 3, imageLobby: 'vertical', imageSection: 'vertical' },
      ],
      context: {
        headerTitle: 'Tournaments',
        prizeFund: '50,000',
        prizeCurrency: 'EUR',
        showWelcomeModal: true,
        templateInstance: {
          resources: {
            background_image: '',
            background_color: '#1a1a2e',
          },
        },
      },
    },
  ],
  restrictions: [],
  languages: ['EN', 'BG', 'DE', 'FR', 'ES'],
  maxJurisdictionalBet: [],
};
